import { Country,country } from '@app/models/agency';
import {gql} from 'apollo-angular';

export interface Address {
  id?: number;
  phone?: string;
  fax?: string;
  street?: string;
  street2?: string;
  poBox?: string;
  zip?: string;
  city?: string;
  country?: Country;
  email?: string;
}

export const address = gql`
  fragment address on Address {
    id
    phone
    fax
    street
    street2
    poBox
    zip
    city
    country {
      ...country
    }
    email
    additionalEmails
  }
  ${country}
`;
